(() => {
  let cleanup;
  function init() {
    if (cleanup) cleanup();
    const root = document.querySelector('[data-event-slideout]');
    if (!root) return;
    root.hidden = true;
    root.classList.remove('std-event-open');
    root.querySelector('[data-event-panel]').hidden = true;
    root.querySelector('[data-event-tab]').hidden = true;
    const config = JSON.parse(root.querySelector('[data-event-config]').textContent);
    if (!config.enabled && !(config.editor && config.preview)) return;
    const panel = root.querySelector('[data-event-panel]');
    const tab = root.querySelector('[data-event-tab]');
    const closeButton = root.querySelector('[data-event-close]');
    const dismissButton = root.querySelector('[data-event-dismiss]');
    const message = root.querySelector('[data-event-status]');
    const key = 'std-event:' + config.campaign;
    let shown = false, start = Date.now();
    try {
      start = Number(sessionStorage.getItem(key + ':start')) || start;
      sessionStorage.setItem(key + ':start', String(start));
      shown = config.frequency === 'day'
        ? Date.now() - (Number(localStorage.getItem(key + ':shownAt')) || 0) < 86400000
        : sessionStorage.getItem(key + ':shown') === 'true';
    } catch (_) {}
    root.hidden = false;
    tab.hidden = false;
    function open(manual) {
      panel.hidden = false;
      tab.hidden = true;
      requestAnimationFrame(() => root.classList.add('std-event-open'));
      shown = true;
      if (!config.editor) { try { sessionStorage.setItem(key + ':shown', 'true'); localStorage.setItem(key + ':shownAt', String(Date.now())); } catch (_) {} }
      if (manual) closeButton.focus();
    }
    function close() {
      root.classList.remove('std-event-open');
      panel.hidden = true;
      tab.hidden = false;
    }
    function openManual() { open(true); }
    function closeManual() { close(); tab.focus(); }
    function onKey(event) { if (event.key === 'Escape' && !panel.hidden) closeManual(); }
    function tick() {
      if (config.editor) return;
      if (!panel.hidden && document.body.classList.contains('show-cart-summary')) close();
      if (config.frequency !== 'manual' && !shown && Date.now() - start >= config.delay * 1000 && !document.querySelector('[data-promo-panel]:not([hidden])') && document.visibilityState === 'visible' && !document.body.classList.contains('show-cart-summary') && !document.body.classList.contains('show-mobile-nav') && !document.body.classList.contains('template-cart')) open(false);
    }
    async function submit(event) {
      const form = event.target.closest('[data-event-product-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button.disabled) return;
      button.disabled = true;
      const text = button.textContent;
      button.textContent = config.adding;
      message.textContent = '';
      try {
        const response = await fetch(config.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || config.error);
        message.textContent = config.added;
        if (window.theme && typeof window.theme.updateCartSummaries === 'function') window.theme.updateCartSummaries(false, true, false);
        document.dispatchEvent(new CustomEvent('std:cart-updated', { detail: data }));
      } catch (error) { message.textContent = error.message || config.error; }
      finally { button.textContent = text; button.disabled = false; }
    }
    function change(event) {
      if (!event.target.matches('[data-event-variant]')) return;
      const option = event.target.selectedOptions[0];
      event.target.closest('[data-event-card]').querySelector('[data-event-price]').textContent = option.dataset.price;
    }
    tab.addEventListener('click', openManual);
    closeButton.addEventListener('click', closeManual);
    dismissButton.addEventListener('click', closeManual);
    root.addEventListener('submit', submit);
    root.addEventListener('change', change);
    document.addEventListener('keydown', onKey);
    const interval = setInterval(tick, 500);
    if (config.editor && config.preview) open(false); else tick();
    cleanup = () => {
      clearInterval(interval); tab.removeEventListener('click', openManual); closeButton.removeEventListener('click', closeManual);
      dismissButton.removeEventListener('click', closeManual); root.removeEventListener('submit', submit); root.removeEventListener('change', change); document.removeEventListener('keydown', onKey);
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
